



















import Product from './Product.vue';
import {Product as ProductType, ProductCategory} from '../types/CheckoutServerData';
import {Component, Vue, Mixins} from 'vue-property-decorator';
import {Mixin} from "@/mixins";
import store from "@/store";

@Component({
    components: {
        Product
    },
    name: "ProductList",
})
export default class ProductList extends Mixins(Mixin) {
    store = store();

    mounted() {
        // specialwish ids
        for (let product of this.store.flatProducts) {
            if (!this.store.serverData.productsSpecialWish[Number(product.id)]) {
                this.$set(this.store.serverData.productsSpecialWish, product.id, '');
            }
        }
    }

    specialWishSave(productId: number, text: string) {
        Vue.set(this.store.serverData.productsSpecialWish, productId, text);
    }

    getSortedProducts(category: ProductCategory): ProductType[] {
        if (category.isDefault) {
            return Object.values(category.products);
        }
        return Object.values(category.products).sort((a, b) => {
            return (a.sort_index || 0) - (b.sort_index || 0);
        });
    }
}
